'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
export default class ResultInfo extends Component {
  render() {
    const {
      gradeType,
      localizedTextKey
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        className: "result-text-small",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `${localizedTextKey}.result.title.${gradeType}`
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "result-description",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `${localizedTextKey}.result.description`
        })
      })]
    });
  }

}
ResultInfo.propTypes = {
  localizedTextKey: PropTypes.string,
  gradeType: PropTypes.string
};